(function () {
  class CashLinkFeature extends PIXI.Container {
    constructor() {
      super();
      this._reels = [];
      this._freeSpinsReels = [];
      this.isFullHouse = undefined;
      this._reelPrizeObjects = [];
      gameController.reelData = [];
      this.powerPackOverlays = {};
      this.newPowerPacks = [];
      this.powerPacks = [];
      this._lockedReels = [];
      this.cashLinkReelSymbols = [];
      this.powerPacksReOrdered = [];
      this.newCoins = [];
      this.powerPackCount = 0;
      this._inFS = false;
      this._currentSpinPositions = [];
      this._currentBaseGameSymbols = [];
      this.coinGlows = [];
      this._prizes = [];
      this._active = false;

      this.cashLinkIntro = undefined;
      this.cashLinkStartData = undefined;
      this.cashLinkStartTask = undefined;
      this._endEvent = undefined;

      this._skipped = false;

      this._reelsTimer = undefined;

      this._endTaskWinnings = 0;

      this._maxWinBreached = false;

      this._megaPotValue = 0;
      this._megaPotWon = false;
      this._coinLandSounds = ["coinLand1", "coinLand2", "coinLand3"];

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "powerPack:cashLinkStartEvent",
        this.onCashLinkStartEvent.bind(this)
      );
      messageBus.subscribe(
        "powerPack:cashLinkDataEvent",
        this.onCashLinkDataEvent.bind(this)
      );
      messageBus.subscribe(
        "powerPack:cashLinkDataEventDead",
        this.onCashLinkDataEventDead.bind(this)
      );
      messageBus.subscribe(
        "powerPack:cashLinkEndEvent",
        this.onCashLinkEndEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEvent",
        this.onFreespinsStart.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsEndEvent",
        this.onFreespinsEndEvent.bind(this)
      );

      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );
      Reflex.registerEventHandler(
        "layoutChange",
        this.onOrientationChange.bind(this)
      );
    }

    //TODO: HB: Why is this hit twice on startup?
    onOrientationChange() {
      if (this._active) {
        if (this.livesRemaining < 0) {
          this.lives.text = "";
        }

        this._slotMachineCL.visible = true;

        switch (layoutController.getCurrentLayout()) {
          case "landscape_default":
          case "landscape_mobile": {
            this._logo = resourceManager.get("logo");
            this.cashlinkBG.visible = true;
            this.cashlinkBGPort.visible = false;
            break;
          }

          case "portrait_default":
          case "portrait_mobile":
          default: {
            this._logo = resourceManager.get("logoPortrait");
            this.cashlinkBG.visible = false;
            this.cashlinkBGPort.visible = true;
            break;
          }
        }
      } else {
        resourceManager.get(
          "slotContainer:cashLinkFeatureContainer:cashLinkFeature"
        ).visible = false;
      }
    }

    onStakeChanged(stake) {
      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      if (
        goldenBetButton !== undefined &&
        goldenBetButton._flags.showGoldenBetActive
      ) {
        stake = stake / gameData.luckyBetUplift;
      }
      this._megaPotValue = stake * 5000;
      this._maxWin = stake * 10000;
    }

    onGameConfigEvent() {
      const self = this;

      this.powerPackDisplay = resourceManager.get(
        "slotContainer:powerPackAwardDisplay"
      );

      this.cashLinkFeatureMainCnt = resourceManager.get(
        "slotContainer:cashLinkFeatureContainer"
      ).children[0];

      this.cashLinkFeatChildren = resourceManager.get(
        "slotContainer:cashLinkFeatureContainer:cashLinkFeature"
      );

      this._slotMachineCL = resourceManager.getController("SlotMachine0_0");

      for (let reel = 0; reel < gameData.numReels; ++reel) {
        let rows = [];
        let freeSpinRows = [];
        this._reelPrizeObjects.push([]);
        for (let row = 0; row < gameData.numRows; ++row) {
          const id = reel * gameData.numRows + row;
          const rv = resourceManager.get(
            "slotContainer:cashLinkFeatureContainer:cashLinkFeature:cashLinkReels:reel" +
              id
          );

          const slotCell = reel * gameData.numRows + row;

          let coinGlow = resourceManager.createObject(
            "sprite",
            `coinGlow${slotCell}`,
            this,
            {
              fileName: "slots/symbols/rotating_glow_00000.png",
              x: gameController.reelData[reel].position.x + 10,
              y:
                gameController.reelData[reel].position.y +
                gameController.reelData[reel]._symbolSpacing * row +
                7,
              anchor: 0.5,
            }
          );
          coinGlow.visible = false;

          let tween = gsap.timeline({ repeat: -1 }).to(coinGlow, {
            rotation: Math.PI * 2,
            duration: 1.1,
            ease: "none",
          });

          let quickTween = gsap.timeline().to(coinGlow, {
            rotation: Math.PI * 4,
            duration: 1,
            ease: "none",
            onStart: () => {
              tween.pause();
              coinGlow.visible = true;
              coinGlow.alpha = 1;
            },
            onComplete: () => {
              tween.restart();
            },
          });

          let winTween = gsap
            .timeline()
            .to(coinGlow, {
              rotation: Math.PI * 4,
              duration: 1,
              ease: "none",
              onStart: () => {
                tween.pause();
                quickTween.pause();
                coinGlow.visible = true;
                coinGlow.alpha = 1;
              },
            })
            .to(coinGlow, {
              alpha: 0,
              duration: 0.3,
              ease: "none",
            });

          quickTween.pause();
          tween.pause();
          winTween.pause();

          this.coinGlows.push({
            sprite: coinGlow,
            tween: tween,
            quickTween: quickTween,
            winTween: winTween,
            playing: false,
          });

          rv.reassignSlotMachine(this._slotMachineCL);
          rows.push(rv);

          const freeSpinReel = resourceManager.get(
            `slotContainer:topValueOverlays:parentContainer${slotCell}:valueContainer`
          );

          freeSpinRows.push(freeSpinReel);

          const prizeContainer = resourceManager.get(
            `slotContainer:topValueOverlays:parentContainer${slotCell}:valueContainer`
          );

          const value = resourceManager.get(
            `slotContainer:topValueOverlays:parentContainer${slotCell}:valueContainer:coinCashOverlay`
          );

          const mini = resourceManager.get(
            `slotContainer:topValueOverlays:parentContainer${slotCell}:valueContainer:miniOverlay`
          );

          const minor = resourceManager.get(
            `slotContainer:topValueOverlays:parentContainer${slotCell}:valueContainer:minorOverlay`
          );

          const major = resourceManager.get(
            `slotContainer:topValueOverlays:parentContainer${slotCell}:valueContainer:majorOverlay`
          );

          const mega = resourceManager.get(
            `slotContainer:topValueOverlays:parentContainer${slotCell}:valueContainer:megaOverlay`
          );

          this._reelPrizeObjects[reel].push({
            container: prizeContainer,
            text: value,
            mini,
            minor,
            major,
            mega,
          });
        }
        this._reels.push(rows);

        this._freeSpinsReels.push(freeSpinRows);
      }

      this._slotMachineCL.selectReelMode("default");

      this._slotMachineCL.subscribeToReelsLandedEvent(function (reelId) {
        self.onSpinLand(reelId);
      });

      this._slotMachineCL.subscribeToReelsHitEvent(function (reelId) {
        self.onSpinHit(reelId);
      });

      for (let i = 0; i < this._slotMachineCL._reelVisuals.length; i++) {
        this._slotMachineCL._reelVisuals[i].suspendUpdates();
      }

      this.cashLinkUI = resourceManager.get(
        "slotContainer:CashlinkUIContainer"
      );

      this.cashLinkUI.visible = false;

      this.lives = resourceManager.get(
        "slotContainer:CashlinkUIContainer:RespinsLivesContainer:lives"
      );

      this.livesTextLabel = resourceManager.get(
        "slotContainer:CashlinkUIContainer:RespinsLivesContainer:livesText"
      );

      this.collectedText = resourceManager.get(
        "slotContainer:CashlinkUIContainer:CoinsCollectedContainer:collected"
      );

      this.powerPackCollectedText = resourceManager.get(
        "slotContainer:CashlinkUIContainer:PowerPacksContainer:powerPackcollected"
      );

      this.cashLinkFlash = resourceManager.get(
        "slotContainer:cashLinkFeatureContainer:cashLinkFeature:cashLinkReels:cashLinkFlash"
      );

      this.cashLinkIntro = resourceManager.get(
        "featurePopupContainer:cashLinkIntroPopup"
      );

      this.cashLinkMessage = resourceManager.get("CashLinkMessage");
      this.cashLinkMessage.visible = false;

      this.cashlinkBG = resourceManager.get(
        "landscapeBackground:freespinsBackground"
      );
      this.cashlinkBG.visible = false;

      this.cashlinkBGPort = resourceManager.get(
        "portraitBackground:freespinsBackground"
      );
      this.cashlinkBGPort.visible = false;

      this.shaker = resourceManager.get("slotShaker");

      this._megaValue = resourceManager.get(
        "slotContainer:cashLinkFeatureContainer:megaValue"
      );
      this._megaValue.visible = false;

      for (let reel = 0; reel < gameData.numReels; reel++) {
        for (let row = gameData.numRows - 1; row >= 0; row--) {
          const orginSymX = gameController.reelData[reel].position.x;
          const orginSymY =
            gameController.reelData[reel].position.y +
            gameController.reelData[reel]._symbolSpacing * row;
          const slotCell = reel * gameData.numRows + row;

          let powerPackOverlay;
          if (reel === 0 || reel === 5) {
            powerPackOverlay = resourceManager.createObject(
              "sprite",
              `powerPackOverlay${slotCell}`,
              this,
              {
                fileName:
                  "slots/symbols/Power_Pack/Power_Pack_symbol_1280_720_00000.png",
                anchor: 0.5,
                x: orginSymX + 8,
                y: orginSymY + 8,
              }
            );
            powerPackOverlay.visible = false;
            this.powerPackOverlays[slotCell] = powerPackOverlay;
          }
        }
      }

      this.visible = false;
      this.cashLinkUI.visible = false;
      this.cashLinkFeatureMainCnt.removeChild(this.cashLinkFeatChildren);
    }

    onCashLinkStartEvent(task) {
      resourceManager.get("slotContainer:multiplierContainer").visible = false;
      this.cashLinkFeatureMainCnt.addChild(this.cashLinkFeatChildren);
      const self = this;
      // set off the intro
      this._active = true;
      this.cashLinkStartTask = task;
      this.cashLinkStartTask.join();
      gameController.reelStopping = [false, false, false, false, false, false];
      gameController.topValueOverlays.clearAllCoinAndPotValues();
      gameController.topValueOverlays.resetValuePostions();
      this.isFullHouse = task.data.megaPotAwarded;
      gameController.cashLinkSkip = true;
      this.cashLinkStartData = task.data;

      for (let i = 0; i < this._slotMachineCL._reelVisuals.length; i++) {
        this._slotMachineCL._reelVisuals[i].clearSuspendUpdates();
      }

      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
        case "landscape_mobile": {
          this.cashlinkBG.visible = true;
          this.cashlinkBGPort.visible = false;
          break;
        }

        case "portrait_default":
        case "portrait_mobile":
        default: {
          this.cashlinkBG.visible = false;
          this.cashlinkBGPort.visible = true;
          break;
        }
      }

      if (gameController.inBuyABonus) {
        gameController.buyABonusCashLink = true;
      }

      gameController.wildLandAnimator.skip();

      for (let reel = 0; reel < gameData.numReels; reel++) {
        gameData.reels[reel].suspendUpdates();
        for (let row = 0; row < gameData.numRows; row++) {
          let slotCell = reel * gameData.numRows + row;

          //show any hidden reels from any previous cashlink games
          gameController.cashLink._slotMachineCL._reelVisuals[
            slotCell
          ].showSymbol(0, true);

          //Animate Bonus Activation Symbols
          let symbolData;
          let winSound;
          if (
            gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
              .value === gameData.symbols["Symbol_Power_Pack"].ID
          ) {
            symbolData = {
              cell: { reel: reel, row: row },
              symbolId: gameData.symbols["Symbol_Power_Pack"].ID,
            };
            this.cashLinkReelSymbols[slotCell] =
              gameData.symbols["Symbol_Power_Pack"].ID;
          }
          if (
            gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
              .value === gameData.symbols["Symbol_Cashlink"].ID
          ) {
            symbolData = {
              cell: { reel: reel, row: row },
              symbolId: gameData.symbols["Cash_link_Coin_Activate"].ID,
            };
            this.cashLinkReelSymbols[slotCell] =
              gameData.symbols["Symbol_Coin"].ID;
            winSound = "cashLinkWin";
          }
          if (symbolData) {
            gameController.bonusLandAnimator.animateSymbols(
              [symbolData],
              gameController.slotMachine,
              true,
              false,
              function () {}
            );
          }
          if (winSound) soundManager.play(winSound);
        }
      }

      for (let i = 0; i < this.cashLinkStartData.startingCoins.length; i++) {
        let symbolData = {
          cell: {
            reel: this.cashLinkStartData.startingCoins[i].slotCell,
            row: 0,
          },
          symbolId: this.cashLinkStartData.startingCoins[i].symbolId,
        };

        this.cashLinkReelSymbols[
          this.cashLinkStartData.startingCoins[i].slotCell
        ] = gameData.symbols["Symbol_Coin"].ID;

        gameController.bonusLandAnimator.animateSymbols(
          [symbolData],
          this._slotMachineCL,
          true,
          false,
          function () {},
          this.cashLinkStartData.startingCoins[i],
          undefined,
          true
        );
      }

      //Wait for bonus landing animations to finish
      timerManager.addTimeout(1500, function () {
        soundManager.play("shake");
        self.shaker.doShake(1500);
        gameData.musicManager.onCashLinkIntro();
        self.cashLinkIntro.showIntro(self.cashLinkStartCallback.bind(self));
      });
    }

    onSpinHit(reelText) {
      if (gameController.inCashLink) {
        const self = this;
        let slotCell = +reelText.replace("reel", "");

        //replace above and below powerpack symbols with low paying symbols
        if (slotCell < 4 || slotCell > 19) {
          if (
            this._slotMachineCL.reels[slotCell]._symbolData[2].symId ===
            gameData.symbols[`Symbol_Power_Pack`].ID
          ) {
            const randSym = Math.floor(Math.random() * (4 - 0 + 1) + 0);
            this._slotMachineCL.reels[slotCell].setReelSymbol(2, randSym);
          }
          if (
            this._slotMachineCL.reels[slotCell]._symbolData[3].symId ===
            gameData.symbols[`Symbol_Power_Pack`].ID
          ) {
            const randSym = Math.floor(Math.random() * (4 - 0 + 1) + 0);
            this._slotMachineCL.reels[slotCell].setReelSymbol(3, randSym);
          }
        }

        if (
          this._slotMachineCL.reels[slotCell]._symbolData[2].symId ===
          gameData.symbols[`Symbol_K`].ID
        ) {
          this._slotMachineCL.reels[slotCell].setReelSymbol(2, 0);
        }

        this.cashLinkReelSymbols[slotCell] =
          this._slotMachineCL.reels[slotCell]._symbolData[0].symId;

        //Play the symbol land animations
        gameController.coinValues = this.newCoins;
        for (let i = 0; i < this.newCoins.length; i++) {
          if (slotCell === this.newCoins[i].slotCell) {
            let reel = this.newCoins[i].reel;
            let row = this.newCoins[i].row;
            let symbolData = {
              cell: {
                reel: slotCell,
                row: 0,
              },
              symbolId: this.newCoins[i].symbolId,
            };

            //TODO: HB Do I need this?
            this._reelPrizeObjects[reel][row].container.visible = true;
            self._lockedReels.push(slotCell);
            self.startCoinGlowAnimation();

            const randIndex = Math.floor(
              Math.random() * self._coinLandSounds.length
            );
            soundManager.play(self._coinLandSounds[randIndex]);

            gameController.bonusLandAnimator.animateSymbols(
              [symbolData],
              this._slotMachineCL,
              true,
              false,
              function () {},
              this.newCoins[i]
            );
          }
        }
        for (let i = 0; i < this.newPowerPacks.length; i++) {
          if (slotCell === this.newPowerPacks[i].slotCell) {
            let reel = this.newPowerPacks[i].reel;
            let row = this.newPowerPacks[i].row;
            let symbolData = {
              cell: {
                reel: slotCell,
                row: 0,
              },

              symbolId: this.newPowerPacks[i].symbolId,
            };

            this._reelPrizeObjects[reel][row].container.visible = true;

            soundManager.play("powerPackLand");

            timerManager.addTimeout(300, function () {
              symbolData.cell.reel = reel;
              symbolData.cell.row = row;
              self.powerPackOverlays[slotCell].alpha = 1;
              self.powerPackOverlays[slotCell].visible = true;
            });
          }
        }

        gameController.cashLinkReelIsSpinSpinning[slotCell] = false;
      }
    }

    onSpinLand(reelText) {
      let slotCount = +reelText.replace("reel", "");

      // if reel that has landed is in the _newLockedReels array
      if (this._newLockedReels.includes(slotCount)) {
        // convert reel to reel/row
        let reel = Math.trunc(slotCount / gameData.numRows);
        let row = slotCount % gameData.numRows;
      }
    }

    setSymbols() {
      this._currentBaseGameSymbols = [];
      // gameController.coinValues = [];
      // this._isWildFire = task.data.isWildFire;
      for (
        let reel = 0;
        reel < gameController.spinTask.data.resultPanel.reelList.length;
        reel++
      ) {
        this._currentBaseGameSymbols.push([]);
        for (
          let row = 0;
          row <
          gameController.spinTask.data.resultPanel.reelList[reel].symbols
            .length;
          row++
        ) {
          this._currentBaseGameSymbols[reel].push(
            gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
              .value
          );
        }
      }
    }

    getNextSpinOutcome() {
      messageBus.post("spinner:stormLink");

      this.livesRemaining--;
      if (this.livesRemaining < 0) {
        messageBus.post("spinner:stormLinkEnd");
      }

      let livesVisible = this.livesRemaining > 0 ? true : false;

      this.lives.visible = livesVisible;

      this.livesTextLabel.setTranslationPhrase(
        this.livesRemaining === 1 ? "t_live" : "t_lives"
      );

      this.lives.text = this.livesRemaining;

      if (this.livesRemaining >= 0) {
        soundManager.play("respinsDecrease");
      }

      gdk.getNextGameOutcome(function () {});
    }

    swapCashLinkSymbol(cb) {
      let self = this;
      let reel = this.cashLinkStartData.cashLinkSymbol.slotCell;
      this._slotMachineCL.reels[reel].setReelSymbol(
        0,
        gameData.symbols["Symbol_Coin"].ID
      );

      const coin = this.cashLinkStartData.cashLinkSymbol;

      this.prizes.push({
        amount: coin.amount,
        reel: coin.reel,
        row: coin.row,
        type: coin.type,
        symbolId: coin.symbolId,
        slotCell: coin.slotCell,
        potName: coin.potName,
        potValue: coin.potValue,
      });

      this._lockedReels.push(this.cashLinkStartData.cashLinkSymbol.slotCell);
      gameController.coinValues.push(this.cashLinkStartData.cashLinkSymbol);
      if (coin.type === "Cash") {
        gameController.topValueOverlays.setCoinValue(
          this.cashLinkStartData.cashLinkSymbol.slotCell,
          this.cashLinkStartData.cashLinkSymbol
        );
        //Hides spin value (just in case)
        gameController.valuesSpin.showSpinCoinValue(
          false,
          this.cashLinkStartData.cashLinkSymbol.slotCell
        );
        gameController.valuesSpin.showSpinCLCoinValue(
          false,
          this.cashLinkStartData.cashLinkSymbol.slotCell
        );
      }

      this.cashLinkFlash.position = helpers.getSymbolPos(coin.reel, coin.row);
      this.cashLinkFlash.position.x += 86;
      this.cashLinkFlash.position.y -= 14;
      this.startCoinGlowAnimation();

      this.cashLinkFlash.gotoAndPlay(0);

      gameController.topValueOverlays.fadeInCashlinkValue(
        self.cashLinkStartData.cashLinkSymbol.slotCell,
        cb,
        coin.type,
        coin.potName
      );
    }

    cashLinkStartCallback() {
      this.cashLinkStartTask.leave();

      resourceManager.getController("inputOverlord").setState("freespins");

      gameController.slotMachine.clearDimSymbolIds();

      this.cashLinkMessage.visible = true;
      this.livesTextLabel.visible = true;

      this.livesRemaining = this.cashLinkStartData.livesRemaining;
      this.lives.text = this.livesRemaining;

      if (this.livesRemaining >= 0) {
        this.lives.visible = true;
      } else {
        this.lives.visible = false;
      }

      this.livesTextLabel.setTranslationPhrase(
        this.livesRemaining === 1 ? "t_live" : "t_lives"
      );

      this.coinsCollected = this.cashLinkStartData.startingCoins.length + 1;

      this.collectedText.setText(this.coinsCollected);

      this.powerPacksCollected = this.cashLinkStartData.powerPacks.length;
      this.powerPackCollectedText.setText(this.powerPacksCollected);

      this._logo = undefined;
      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
        case "landscape_mobile": {
          this._logo = resourceManager.get("logo");
          break;
        }

        case "portrait_default":
        case "portrait_mobile":
        default: {
          this._logo = resourceManager.get("logoPortrait");
          break;
        }
      }

      this._logo.visible = false;

      this._lockedReels = [];
      this._newLockedReels = [];
      this.prizes = [];
      this.powerPacks = [];
      this.powerPacksReOrdered = [];
      this.setSymbols();

      const symbolInfo = resourceManager.getConfiguration().symbols;
      //transfer base game symbols over to these reels
      for (let reel = 0; reel < gameData.numReels; reel++) {
        for (let row = 0; row < gameData.numRows; row++) {
          let symbolId = this._currentBaseGameSymbols[reel][row];

          /*TODO May need this for super wilds
           if (
             this._isWildFire &&
             symbolId >= symbolInfo["Symbol_Coin32"].ID &&
             symbolId <= symbolInfo["Symbol_CoinMega"].ID
           ) {
             const count = symbolId - symbolInfo["Symbol_Coin32"].ID;
             symbolId = symbolInfo["Symbol_BlueFireball20"].ID + count;
             gameData.reels[reel].setReelSymbol(row, symbolId);
           }
           if (
             symbolId === symbolInfo["Symbol_Wild_1x2"].ID ||
             symbolId === symbolInfo["Symbol_Wild_1x3"].ID
           ) {
             symbolId = symbolInfo["Symbol_SWild"].ID;
           }#*/
          this._reels[reel][row].setReelSymbol(0, symbolId);
        }
      }

      for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
        gameController.hideOversized(gameController.overSizedSymbols[i]);
      }

      const self = this;

      this.cashLinkStartData.startingCoins.forEach(function (coin) {
        gameController.valuesSpin.showSpinCLCoinValue(false, coin.slotCell);
        self._lockedReels.push(coin.slotCell);
        let amount;
        if (coin.type === "Pot") {
          gameController.topValueOverlays.showPotValue(
            true,
            coin.slotCell,
            coin.potName
          );
        } else {
          gameController.topValueOverlays.setCoinValue(coin.slotCell, coin);
          gameController.topValueOverlays.showCoinValue(true, coin.slotCell);
        }
        self.prizes.push({
          amount: coin.amount,
          reel: coin.reel,
          row: coin.row,
          type: coin.type,
          symbolId: coin.symbolId,
          slotCell: coin.slotCell,
          potName: coin.potName,
          potValue: coin.potValue,
        });
      });

      this.isWinCapped = this.cashLinkStartData.winCapped;

      resourceManager.get("slotContainer:reelContainer").visible = false;
      this.visible = true;
      this.cashLinkUI.visible = true;
      let symbolsToDim = [];

      for (let i = 0; i < 7; i++) {
        symbolsToDim.push(i);
      }

      for (let rv = 0; rv < this._slotMachineCL._reelVisuals.length; rv++) {
        this._slotMachineCL._reelVisuals[rv].dimSymbolIds(symbolsToDim);
      }

      this.cashLinkStartData.powerPacks.forEach(function (pack) {
        let symbolData = {
          cell: { reel: pack.reel, row: pack.row },
          symbolId: gameData.symbols[`Symbol_Power_Pack_Oversized`].ID,
          oversizedSymbolID: gameData.symbols[`Symbol_Power_Pack_Oversized`].ID,
        };

        gameController.hideOversized(
          symbolData,
          gameData.symbols[`Symbol_Power_Pack_Oversized`].ID
        );
        self.powerPackOverlays[pack.slotCell].alpha = 1;
        self.powerPackOverlays[pack.slotCell].visible = true;
        self._lockedReels.push(pack.slotCell);
        self.powerPacks.push({
          reel: pack.reel,
          row: pack.row,
          slotCell: pack.slotCell,
          symbolId: pack.symbolId,
        });
      });

      //Cashlink Coin coversion
      this.swapCashLinkSymbol(function () {
        self.getNextSpinOutcome();
      });
    }

    doSlamStop() {
      if (this._active) {
        let reelsToSlam = [];

        for (var i = 0; i < gameData.slotCellCount; i++) {
          reelsToSlam.push(i);
        }
        this._slotMachineCL.slamReels(reelsToSlam);

        if (this._reelsTimer !== undefined) {
          this._reelsTimer.remainingTime = 0;
        }
      }
    }

    onCashLinkDataEvent(task) {
      this._dataEvent = task;
      this._dataEvent.join();

      this._lockedReels.push(...this._newLockedReels);
      this._newLockedReels = [];
      this.newPowerPacks = [];
      this.newCoins = [];

      this._slotMachineCL.holdReels(this._lockedReels);

      this._lockedReels.forEach((element) => {
        gameController.cashLinkReelIsSpinSpinning[element] = false;
      });

      this._slotMachineCL.infiniteSpin();

      this._currentSpinPositions = [];

      const self = this;
      let aboveBelow = [];

      //set up defaults so the held reels have the data (even though that data wont be used)
      this._reels.forEach(function (reel) {
        reel.forEach(function (row) {
          aboveBelow.push([]);
          self._currentSpinPositions.push([0]);
        });
      });

      task.data.newCoins.forEach(function (coin) {
        gameData.reels[coin.reel].setReelSymbol(coin.row, coin.symbolId);
        self._currentSpinPositions[coin.slotCell] = [coin.symbolId];
        self._newLockedReels.push(coin.slotCell);

        self.prizes.push({
          amount: coin.amount,
          reel: coin.reel,
          row: coin.row,
          type: coin.type,
          symbolId: coin.symbolId,
          slotCell: coin.slotCell,
          potName: coin.potName,
          potValue: coin.potValue,
        });

        gameController.topValueOverlays.setCoinValue(coin.slotCell, coin);
      });

      task.data.newPowerPacks.forEach(function (pack) {
        gameData.reels[pack.reel].setReelSymbol(pack.row, pack.symbolId);

        self._currentSpinPositions[pack.slotCell] = [pack.symbolId];
        self._newLockedReels.push(pack.slotCell);

        self.powerPacks.push({
          reel: pack.reel,
          row: pack.row,
          slotCell: pack.slotCell,
          symbolId: pack.symbolId,
        });
      });

      this.newPowerPacks = task.data.newPowerPacks;
      this.newCoins = task.data.newCoins;

      // Add spins coin amount collected
      this.coinsCollected += task.data.newCoins.length;
      this.powerPacksCollected += task.data.newPowerPacks.length;

      if (task.data.newCoins.length > 0) soundManager.play("coinsAdd");
      if (task.data.newPowerPacks.length > 0) soundManager.play("powerPackAdd");

      task.data.blanks.forEach(function (blank) {
        let slotCell = blank.coord.reel * gameData.numRows + blank.coord.row;
        gameController.cashLinkReelIsSpinSpinning[slotCell] = true;
        const id = blank.coord.reel * gameData.numRows + blank.coord.row;
        self._currentSpinPositions[id] = [blank.symbol];
      });
      this._reelsTimer = timerManager.addTimeout(200, function () {
        self._slotMachineCL.stopReels(
          self._currentSpinPositions,
          aboveBelow,
          aboveBelow,
          function () {
            self.livesRemaining = task.data.livesRemaining;

            let livesVisible = self.livesRemaining > 0 ? true : false;

            if (self.livesRemaining === 3) {
              soundManager.play("respinsReset");
              gameData.musicManager.increaseLevel("cashLink");
            }

            if (livesVisible) {
              self.lives.text = self.livesRemaining;
              self.lives.visible = true;
            } else {
              self.lives.visible = false;
            }

            self.livesTextLabel.setTranslationPhrase(
              self.livesRemaining === 1 ? "t_live" : "t_lives"
            );

            timerManager.addTimeout(200, function () {
              self._dataEvent.leave();
            });
          }
        );
      });
    }

    onCashLinkDataEventDead(task) {
      this.powerPackCollectedText.setText(this.powerPacksCollected);
      this.collectedText.setText(this.coinsCollected);
      const self = this;

      if (task.newCoins.length) {
        timerManager.addTimer(
          500,
          function (progress) {
            const scale = InterpolationHelper.interpolateSine(
              1,
              1.25,
              progress
            );
            self.collectedText.scale.set(scale, scale);
          },
          function () {
            self.collectedText.scale.set(1, 1);
          }
        );
      }

      if (task.livesRemaining <= 0) {
        for (let i = 0; i < self._lockedReels.length; i++) {
          self.coinGlows[self._lockedReels[i]].playing = false;
          const coinGlow = self.coinGlows[self._lockedReels[i]].sprite;
          gsap.to(coinGlow, {
            duration: 0.3,
            alpha: 0,
          });
        }
      }
      this.getNextSpinOutcome();
    }

    startCoinGlowAnimation() {
      const self = this;
      for (let i = 0; i < self._lockedReels.length; i++) {
        if (
          self._lockedReels[i] > 3 &&
          self._lockedReels[i] < 20 &&
          !self.coinGlows[self._lockedReels[i]].playing
        ) {
          //do not want to include powerpack reels
          self.coinGlows[self._lockedReels[i]].playing = true;
          self.coinGlows[self._lockedReels[i]].quickTween.restart();
        }
      }
    }

    stopCoinTimedGlowAnimation() {
      timerManager.stop(this.coinGlow);
    }

    processPrizes(callback) {
      this._multipliers = [];
      this.currentPrizeIndex = 0;

      gameController.cashLinkPayout = true;

      if (this._skipped) {
        this.skipped(callback);
      } else {
        this.processNextPrize(callback);
      }
    }

    skip() {
      this._skipped = true;
    }

    skipped(callback) {
      let total = this._megaPotWon ? this._megaPotValue : 0;
      let multiplier = 1;

      for (let i = 0; i < this.prizes.length; i++) {
        let prize = this.prizes[i];
        let prizeType = prize.prizeData.type;

        if (
          prizeType === "Cash" ||
          prizeType === "WildCash" ||
          prizeType === "Pot" ||
          prizeType === "WildPot"
        ) {
          total += prize.prizeData.value;
        } else if (
          prizeType === "Multiplier" ||
          prizeType === "WildMultiplier"
        ) {
          multiplier *= prize.prizeData.value;
        }
      }

      this.countUpToNumber(total * multiplier, callback, 1000);

      soundManager.play("coinSplash");
    }

    getCurrentMaxWin() {
      if (gameController.inFirelink) {
        return this._maxWin - gameController.freespinsWinnings;
      } else {
        return this._maxWin;
      }
    }

    setWinnings(newWinnings) {
      this._winnings = newWinnings;
    }

    startShowPrizesFromExt(winnings) {
      this._winnings = winnings;
      this._winningsText.setText(gdk.formatCurrency(winnings));
    }

    onCashLinkEndEvent(task) {
      task.join();
      this._endEvent = task;

      this._endTaskWinnings = task.data.winAmount;

      this._megaPotWon = false;

      this._reelsTimer = undefined;
      messageBus.post("spinner:stormLinkEnd");

      this._winnings = 0;
      const self = this;

      this.stopCoinTimedGlowAnimation();
      this.powerPackDisplay.startCashLinkDisplay(
        this.prizes,
        this.powerPacks,
        task.data.winAmount,
        this.isWinCapped,
        function () {
          self.endFeature();
        },
        this.isFullHouse
      );
    }

    animateQuickCoinGlow(slotCell) {
      this.coinGlows[slotCell].tween.restart();
      this.coinGlows[slotCell].quickTween.restart();
      this.coinGlows[slotCell].tween.pause();
      this.coinGlows[slotCell].quickTween.pause();
      this.coinGlows[slotCell].winTween.restart();
    }

    doBigWin() {
      this.endFeature();
    }

    stopGlows() {
      for (let i = 0; i < this._lockedReels.length; i++) {
        this.coinGlows[this._lockedReels[i]].playing = false;
        this.coinGlows[this._lockedReels[i]].quickTween.pause();
        this.coinGlows[this._lockedReels[i]].tween.pause();
        this.coinGlows[this._lockedReels[i]].sprite.visible = false;
      }
    }

    endFeature() {
      const self = this;
      gameController.wasCashLink = true;

      for (const pack of Object.keys(this.powerPackOverlays)) {
        this.powerPackOverlays[pack].visible = false;
        this.powerPackOverlays[pack].alpha = 0;
      }

      this.cashLinkMessage.visible = false;
      this.powerPacks = [];
      this.powerPacksReOrdered = [];
      gameController.cashLinkPayout = false;

      this._skipped = false;

      gameController.coinValues = this.prizes;
      this.prizes = [];

      /*NOTE: Set cashlink symbol to basegame reels*/
      gameController.slotMachine.reels[
        this.cashLinkStartData.cashLinkSymbol.reel
      ].setReelSymbol(
        [this.cashLinkStartData.cashLinkSymbol.row],
        gameData.symbols["Symbol_Coin"].ID
      );

      if (this.cashLinkStartData.cashLinkSymbol.type === "Cash") {
        gameController.valuesSpin.setCoinSpinValue(
          this.cashLinkStartData.cashLinkSymbol.slotCell,
          this.cashLinkStartData.cashLinkSymbol.amount
        );
        gameController.valuesSpin.showSpinCoinValue(
          true,
          this.cashLinkStartData.cashLinkSymbol.slotCell
        );
      } else {
        gameController.valuesSpin.showSpinPotValue(
          true,
          this.cashLinkStartData.cashLinkSymbol.slotCell,
          this.cashLinkStartData.cashLinkSymbol.potName
        );
      }

      timerManager.addDelayedTimer(
        500,
        250,
        function (progress) {},
        function () {
          if (gameController.inFreeSpins) {
            resourceManager.get(
              "slotContainer:multiplierContainer"
            ).visible = true;
          }
          resourceManager.get("slotContainer:reelContainer").visible = true;
          self.stopGlows();
          this._lockedReels = [];
          this._newLockedReels = [];

          gameController.coinValues.forEach((coin) => {
            gameController.topValueOverlays.resetValues(coin.slotCell);
            if (coin.type === "Cash") {
              gameController.valuesSpin.showSpinCoinValue(true, coin.slotCell);
            } else {
              gameController.valuesSpin.showSpinPotValue(
                true,
                coin.slotCell,
                coin.potName
              );
            }
          });

          gameController.inCashLink = false;
          gameController.slamStopped = false;
          gameController.buyABonusCashLink = false;
          self.cashlinkBG.visible = false;
          self.cashlinkBGPort.visible = false;
          self._slotMachineCL.clearDimSymbolIds();
          self.cashLinkUI.visible = false;
          self.visible = false;
          for (let reel = 0; reel < gameData.numReels; reel++) {
            gameData.reels[
              reel
            ].onSpin(); /*a bit hacky but i'm transferring data over to the spin coins*/
            gameData.reels[reel].redraw();
            gameData.reels[reel].clearSuspendUpdates();
            for (let row = 0; row < gameData.numRows; row++) {
              const slotCell = reel * gameData.numRows + row;

              self._slotMachineCL._reelVisuals[slotCell].suspendUpdates();

              if (
                self.cashLinkReelSymbols[slotCell] !=
                  gameData.symbols["Symbol_Coin"].ID &&
                self.cashLinkReelSymbols[slotCell] !=
                  gameData.symbols["Symbol_Power_Pack"].ID
              ) {
                gameController.slotMachine.reels[reel].setReelSymbol(
                  [row],
                  self.cashLinkReelSymbols[slotCell]
                );
              }
            }
          }

          gameController.onStakeChanged(
            resourceManager
              .getController("stakeController")
              .getCurrentStake("default"),
            false
          );

          self._endEvent.leave();
          self.cashLinkFeatureMainCnt.removeChild(self.cashLinkFeatChildren);
          gameController.messageBox.showLogo(true);
          self._endEvent = undefined;
          self._active = false;
        }
      );
    }

    onFreespinsStart() {
      this._inFS = true;
    }

    onFreespinsEndEvent() {
      this._inFS = false;
    }

    skip() {
      this._skipped = true;
    }
  }

  var cashLinkFeatureCreator = function (json) {
    return new CashLinkFeature();
  };

  var cashLinkFeatureInitialiser = function (json, cashLinkFeature) {};

  var cashLinkFeatureFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "cashLinkFeature",
    cashLinkFeatureCreator,
    cashLinkFeatureInitialiser,
    cashLinkFeatureFilesRequired
  );
})();
